import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@/components/page";
import { AgendaItems } from "@/components/agendaModules/AgendaItems";
import { useDisableTeam } from "@/components/page/disableTeam";
import { RoleProtected } from "@/components/common/RoleProtected";
import { Button } from "@repo/ui/components/Base/Button";
import { useUserStore } from "@/stores/userStore";
import { useState } from "react";
import { AgendaModuleForm } from "@/components/agendaModules/AgendaModuleForm";
import { useGetAgendaModule } from "@/hooks/queryHooks/agendaModuleHooks";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";

export const AgendaModulePage = () => {
  const { tenantId, agendaModuleId } = useParams();
  const navigate = useNavigate();
  const activeTeam = useUserStore((s) => s.activeTeam);
  const activeTeamId =
    activeTeam && activeTeam !== "org" ? activeTeam.id : "org";

  useDisableTeam();

  const [formKey, setFormKey] = useState(0);
  const resetForm = () => setFormKey((key) => key + 1);

  const { data: tenantData } = useGetTenantByFriendly(tenantId ?? "");
  const { data: agendaModuleData } = useGetAgendaModule(
    tenantData?.id ?? "",
    agendaModuleId ?? ""
  );

  const teamMismatch = agendaModuleData?.teamId != activeTeamId;

  const [agendaModuleViewOnly, setAgendaModuleViewOnly] = useState(true);

  if (!agendaModuleData || !tenantData) return null;

  const handleEditAgendaModule = () => {
    setAgendaModuleViewOnly(false);
  };

  const handleComplete = () => {
    setAgendaModuleViewOnly(true);
  };

  const handleCancel = () => {
    setAgendaModuleViewOnly(true);
    resetForm();
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader title={`${tenantData.name}: ${agendaModuleData.name}`}>
        {" "}
      </PageHeader>
      <RoleProtected minRole="edit">
        <div className="flex flex-row justify-end pb-2">
          <Button
            tooltip={
              teamMismatch
                ? "You are in the wrong team to be editing this agenda section"
                : "Edit Agenda Section"
            }
            onClick={handleEditAgendaModule}
            disabled={teamMismatch || !agendaModuleViewOnly}
          >
            Edit
          </Button>
        </div>
      </RoleProtected>
      {tenantData?.id && (
        <div className="flex flex-row gap-4 justify-center">
          <div className="w-0 flex-grow-[2]">
            <AgendaModuleForm
              key={formKey}
              viewOnly={agendaModuleViewOnly}
              tenantId={tenantData.id}
              agendaModuleFormData={agendaModuleData}
              isTemplate={agendaModuleData.template ?? false}
              handleCancel={handleCancel}
              handleComplete={handleComplete}
              handleGoBack={handleGoBack}
            />
          </div>
          <div className="w-0 flex-grow">
            <AgendaItems
              agendaModule={agendaModuleData}
              tenantId={tenantData.id}
            />
          </div>
        </div>
      )}
    </div>
  );
};
